import {useTranslation} from '@aboutyou/i18n';
import {styled as linariaStyled} from '@linaria/react';
import React, {ButtonHTMLAttributes} from 'react';
import sc from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {UnstyledButton} from '../../atoms/Buttons/UnstyledButton';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  expanded?: boolean;
}

export const ExpandButton = ({
  expanded,
  ref,
  ...rest
}: Props & {ref?: React.Ref<HTMLButtonElement>}) => {
  const {t} = useTranslation();
  const collapseLabel = t('Less filters');
  const expandLabel = t('More filters');

  return (
    <ToggleWrapper
      data-testid="ShowMoreFiltersButton"
      {...rest}
      ref={ref}
      aria-label={undefined}
    >
      <ToggleLabel data-testid="ToggleLabel">
        {expanded ? collapseLabel : expandLabel}
      </ToggleLabel>
      <ToggleIcon
        size={'XS'}
        asset={GenericIconName.ArrowRight}
        $expanded={expanded}
        data-testid="ToggleIcon"
      />
    </ToggleWrapper>
  );
};

const ToggleIcon = linariaStyled(Icon)<{$expanded?: boolean}>`
  display: block;
  opacity: 0.275;
  margin: 2px 0 0 6px;
  z-index: 1;
  transition: 0.15s;
  transform: ${({$expanded}) =>
    $expanded ? 'rotate(270deg)' : 'rotate(90deg)'};
`;

const ToggleLabel = sc.span`
  position: relative;
  z-index: 0;
`;

const ToggleWrapper = linariaStyled(UnstyledButton)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: ${COLORS.Grey1};
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.light};
  line-height: 32px;
  border: none;
  background-color: ${COLORS.White};

  &:focus {
    outline: 0;
  }

  &:hover {
    cursor: pointer;
    color: ${COLORS.Black};

    ${ToggleIcon} {
      opacity: 1;
    }
  }
`;
